import styled from 'styled-components'

import { helpers } from 'styles'

export const IconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	flex-grow: 0;
	background-color: ${helpers.color.iconBackground};
	border-radius: 100%;
	width: 36px;
	height: 36px;
	color: ${helpers.color.textContrast};
`
